'use client';

import FormTextField from '@/components/ui/FormTextField';
import type { FormField } from '@/lib/contentful/types';
import { ValidationMessages } from '@/lib/i18n/contactFormI18n';

const FormFieldRenderer = ({
  field,
  validationMessages,
}: FormFieldRendererProps) => {
  return (
    <FormTextField
      name={field.name}
      label={field.label}
      placeholder={field.placeholder}
      required={field.isRequired}
      inputType={field.inputType}
      validationType={field.validationType}
      messages={validationMessages}
    />
  );
};

export default FormFieldRenderer;

type FormFieldRendererProps = {
  field: FormField;
  validationMessages: ValidationMessages;
};
